<template>
<div class="page-container-v2">
    <page-header
        :title="$t('productslist_header_title')"
        :sub-title="$t('productslist_header_desc')"
    >
        <template #rightArea>
            <div class="page-header-right-area">
                <a-button 
                    type="primary" 
                    @click="uploadBulkFile"
                    class="no-mobile"
                >
                    <i class="fa-regular fa-plus" />
                    {{ $t('productslist_upload_bulk') }}
                </a-button>
                <a-button 
                    type="primary"
                    class="no-mobile" 
                    @click="downloadBulkExample"
                >
                    <i class="fa-solid fa-down-to-bracket" />
                    {{ $t('productslist_download_example') }}
                </a-button>
                <a-button 
                    type="primary"
                    @click="openModal(modalType.create)"
                >
                    <i class="fa-regular fa-plus" />
                    {{ $t('productslist_add_product_single') }}
                </a-button>
                <input 
                    type="file"
                    ref="bulkFileInput"
                    style="width: 0; height: 0; display: none;"
                />
            </div>
        </template>
    </page-header>
    <div class="card-body px-0 pt-0 pb-2 table-with-search">
        <div class="col-xs-12 table-info-filter">
            <div class="total-div">
                <p>
                    {{ $t('common_total') }} <span class="number-highlight">{{ formatCommaNumber(listSize) }}</span>{{ $t('common_case') }}
                </p>
            </div>
            <div class="search-container">
                <a-select 
                    style="width: 150px"
                    v-model:value="rowsPerPage" 
                    @change="handleRowsPerPage"
                >
                    <a-select-option :value="10">10{{ $t('common_searchfilter_rowsperpage') }}</a-select-option>
                    <a-select-option :value="20">20{{ $t('common_searchfilter_rowsperpage') }}</a-select-option>
                    <a-select-option :value="50">50{{ $t('common_searchfilter_rowsperpage') }}</a-select-option>
                </a-select>
                <div class="search-div">
                    <a-select 
                        v-model:value="searchFilter" 
                        id="searchFilter"
                        style="width: 100px;"
                        class="no-radius-right"
                    >
                        <a-select-option value="" selected>
                            {{ $t('productslist_search_choose') }}
                        </a-select-option>
                        <a-select-option value="itemName">
                            {{ $t('productslist_search_item_name') }}
                        </a-select-option>
                        <a-select-option value="productCode">
                            {{ $t('productslist_search_product_code') }}
                        </a-select-option>
                    </a-select>
                    <div class="typing-area">
                        <a-input
                            :placeholder="$t('productslist_search_placeholder')"
                            v-model:value="condition"
                            @keyup.enter="enter"
                            class="no-radius-all"
                            style="height: 100%; width: 250px;"
                        />
                        <a-button 
                            style="height: 100%;"
                            @click="enter" 
                            class="black no-radius-left"
                        >
                            {{ $t('productslist_search') }}
                        </a-button>
                    </div>
                </div>
            </div>
        </div>
        <a-table class="ant-table-striped"
            size="small"
            :columns="columns"
            :data-source="responseData"
            :pagination="false"
            v-if="responseData.length > 0"
        >
            <template #bodyCell="{ column, record }">
            </template>
        </a-table>
        <div class="no-result-container" v-else>
            <i class="fa-solid fa-exclamation-triangle" />
            <span>{{ computedNoResultMessage }} </span>
        </div>
    </div>
    <pagination 
        v-if="!$store.state.isLoading && responseData.length > 0"
        :page-info="paginationData"
        page-name="ProductList"
        
        @change-page="paginationHandler"
    />
</div>
<ProductDetailM 
    :id="modal.targetId"
    :show-modal="modal.modify.show"
    @close-modal="closeModal(modalType.modify)"
    @getProductsList="getProductsList"
/>
<ProductDetailW
    :show-modal="modal.create.show"
    @close-modal="closeModal(modalType.create)"
    @getProductsList="getProductsList"
/>
<ProductDetailR 
    :id="modal.targetId"
    :show-modal="modal.read.show"
    @close-modal="closeModal(modalType.read)"
/>
</template>

<script>
import ProductDetailM from './components/ProductDetailM.vue';
import ProductDetailW from './components/ProductDetailW.vue';
import ProductDetailR from './components/ProductDetailR.vue';
import NoResult from '@/views/components/NoResult.vue';
import Pagination from '@/views/components/Pagination.vue';
import PageHeader from '@/views/components/PageHeader.vue';
import { convertDate, oneBtnDialog, confirmDialog, changeBytesToMegabytes, formatCommaNumber,  } from '@/utils/utils';
import { enums } from '@/utils/enums';
import { modalType } from './enums/enums';
import dayjs from "dayjs";
import 'dayjs/locale/ko'

// <router-link to="/product-list/csv-upload" tag="button" 
//                 class="header-btn btn-hover"
//               >
//                 <i class="fa-regular fa-plus" />
//                 {{ $t('productslist_add_product_bulk') }}
//               </router-link>
export default {
    name: 'ProductsList',
    components: {
        ProductDetailM,
        ProductDetailW,
        ProductDetailR,
        NoResult,
        Pagination,
        PageHeader,
    },
    computed: {
        computedNoResultMessage() {
            if(this.calledApiTimes <= 1) {
                return this.$i18n.t('noresult_product');
            } else {
                return this.$i18n.t('noresult_search');
            }
        },
    },
    data() {
        return {
            modalType,
            formatCommaNumber,
            isInputFocused: false,
            // 타입
            type: 'HOSPITAL',
            // 목록 받아오는 변수
            responseData: [],

            // 페이지네이션 관련 변수
            searchFilter: '',
            condition: '',
            calledApiTimes: 0,
            modal: {
                targetId: '',
                read: {show: false,},
                modify: {show: false,},
                create: {show: false,},
            },
            selectedProduct: '',
            productDetailData: {},
            columns:[
                {
                    key: 'index', title: this.$t('productslist_table_no'), dataIndex: 'index', align: 'center', width: "4%",
                },
                {
                    key: 'productType', title: this.$t('productslist_table_type'), dataIndex: 'productType', align: 'start',
                },
                {
                    key: 'itemName', title: this.$t('productslist_table_name'), dataIndex: 'itemName', align: 'start',
                },
                {
                    key: 'productCode', title: this.$t('productslist_table_code'), dataIndex: 'productCode', align: 'start',
                },
                {
                    key: 'itemNo', title: this.$t('productslist_table_dup'), dataIndex: 'itemNo', align: 'start',
                        customRender: ({text, record}) => {
                            return record.itemNo === 0 ? '-' : record.itemNo
                        },
                },
                {
                    key: 'warrantyStatus', title: this.$t('productslist_table_status'), dataIndex: 'warrantyStatus', align: 'center',
                        customRender: ({text, record}) => {
                            return (
                                <div className="status-wrap-align">
                                    <div className={`status-wrap ${record.warrantyStatus}`}>
                                    <span className="required-span"/>
                                    {this.convertCodeToText(record.warrantyStatus)}
                                    </div>
                                </div>
                            )
                        },
                },
                {
                    key: 'createAt', title: this.$t('productslist_table_createdat'), dataIndex: 'createAt', align: 'start',
                        customRender: ({text, record}) => {
                            return convertDate(record.createAt)
                        },
                },
                {
                    key: 'surgeryInfo', title: this.$t('productslist_table_surgeryat'), dataIndex: 'surgeryInfo', align: 'center',
                        customRender: ({text, record}) => {
                            if(record.surgeryInfo) return convertDate(record.surgeryInfo.surgeryAt);
                            return '-';
                        },
                },
                {
                    key: 'hospitalName', title: this.$t('productslist_table_hospital'), dataIndex: 'hospitalName', align: 'center',
                },
                {
                    key: 'detail-button', title: this.$t('productslist_table_detail'), dataIndex: 'detail-button', align: 'center',
                    customRender: ({text, record}) => {
                        // @click="openModal(modalType.create)"
                        return (
                            <div
                                style="width: 100%; justify-content: center; display: flex;"
                            >
                                <a-button 
                                    shape="circle" 
                                    onClick={() => this.openModal(modalType.read, record._id)}
                                    icon={<i class="fa-light fa-ellipsis"/>}
                                />
                            </div>
                        )
                    },
                },
                {
                    key: 'modify-button', title: this.$t('productslist_table_modify'), dataIndex: 'modify-button', align: 'center',
                    customRender: ({text, record}) => {
                        if(record.warrantyStatus === enums().WarrantyStatusEnum.DISPOSED) {
                            return '';
                        }
                        return (
                            <div
                                style="width: 100%; justify-content: center; display: flex;"
                            >
                                <a-button 
                                    shape="circle" 
                                    onClick={() => this.openModal(modalType.modify, record._id)}
                                    icon={<i class="fa-regular fa-pen-to-square"/>}
                                />
                            </div>
                        )
                    },
                },
                {
                    key: 'dispose-button', title: this.$t('productslist_table_dispose'), dataIndex: 'dispose-button', align: 'center',
                    customRender: ({text, record}) => {
                        if(record.warrantyStatus === enums().WarrantyStatusEnum.DISPOSED) {
                            return '';
                        }
                        return (
                        <div
                                style="width: 100%; justify-content: center; display: flex;"
                            >
                                {record.warrantyStatus !== 'dispose' && (
                                    <a-button 
                                    shape="circle"
                                    onClick={() => this.deleteProduct(record._id)} 
                                    icon={<i className="fa-solid fa-trash-can"/>}
                                    />
                                )}
                                {record.warrantyStatus === 'dispose' && (
                                    <a-button 
                                    shape="circle"
                                    onClick={() => this.restoreProduct(record._id)}
                                    icon={<i className="fa-sharp fa-solid fa-rotate-left"/>}
                                    />
                                )}
                                </div>
                        )
                    },
                },
            ],

            listSize: 0,
            rowsPerPage: 10, 
            paginationData: {
                currentPage: 1, 
                totalPages: 0,
            },
        };
    },
    async mounted() {
        const obj = {};
        obj.page = this.paginationData.currentPage;
        this.paginationHandler(obj);
    },
    
    methods: {
        convertDate,
        async closeModal(type, value) {
            this.modal[type].show = value;
        },
        async openModal(type, id) {
            if(id) this.modal.targetId = id;
            this.modal[type].show = true;
        },
        // 주요 API
        async paginationHandler(childPassParam) {
            this.paginationData.currentPage = childPassParam.page;
            await this.getProductsList();
        },
        // 전체 목록 가져오기
        async getProductsList() {
            const params = {};
            params.page = this.paginationData.currentPage;
            params.limit = this.rowsPerPage;
            if (this.searchFilter !== '' && this.condition !== '') {
                params.search = this.searchFilter;
                params.condition = this.condition;
            }
            try {
                const response = await this.$apiInstance.get(`/products`, { params });
                if (response.status === 200 || response.status === 201) {
                    this.calledApiTimes ++;
                    if(response.data.docs) {
                        this.responseData = response.data.docs;
                    } else {
                        this.responseData = [];
                    }
                    this.listSize = response.data.totalDocs;
                    for (let i = 0; i < this.responseData.length; i++) {
                        this.responseData[i].index = this.listSize - (this.paginationData.currentPage - 1) * this.rowsPerPage  - i;
                    }
                    this.paginationData.totalPages = response.data.totalPages;
                }
            } catch (error) {
                console.log(error);
                await oneBtnDialog(this.$i18n.t('productslist_load_err_title'), this.$i18n.t('productslist_load_err_content'), false);
            }
        },
        // 제품 상세
        async getProductDetail(productId) {
            try {
                const response = await this.$apiInstance.get(`/products/${productId}`);
                if (response.status === 200 || response.status === 201) {
                    this.productDetailData = response.data;
                    this.productDetailData.productId = productId;
                    if (response.data.jsonContents) {
                        this.productDetailData.jsonContents = JSON.parse(
                            response.data.jsonContents
                        );
                    }
                }
            } catch (error) {
                console.log(error);
                oneBtnDialog(this.$i18n.t('productslist_single_load_err_title'), this.$i18n.t('productslist_single_load_err_content'), false);
            }
        },
        //제품 삭제
        async deleteProduct(productId) {
            this.selectedProduct = productId;
            try {
                const confirmResult = await confirmDialog(this.$i18n.t('productslist_dispose_title'), this.$i18n.t('productslist_dispose_msg'));
                if (confirmResult) {
                    const response = await this.$apiInstance.put(`/products/dispose/${this.selectedProduct}`);
                    if (response.status === 200 || response.status === 201) {
                        await oneBtnDialog(this.$i18n.t('productslist_delete_done_msg_title'), this.$i18n.t('productslist_delete_done_msg_content'), false);
                        await this.getProductsList();
                    } 
                }
            } catch(error) {
                console.log(error);
                await oneBtnDialog(this.$i18n.t('productslist_delete_fail_msg_title'), this.$i18n.t('productslist_delete_fail_msg_content'), false);
            }
        },
        // 제품 복구
        async restoreProduct(productId) {
            this.selectedProduct = productId;
            const confirmResult = await confirmDialog(this.$i18n.t('productslist_restore_title'), this.$i18n.t('productslist_restore_msg'));
            if(!confirmResult) return;

            try {
                const response = await this.$apiInstance.put(`/products/restore/${this.selectedProduct}`);
                if (response.status === 200 || response.status === 201) {
                    await oneBtnDialog(
                        this.$i18n.t('productslist_restore_done_msg_title'),
                        this.$i18n.t('productslist_restore_done_msg_content'),
                        false
                    );
                    await this.getProductsList();
                } else {
                    await oneBtnDialog(
                        this.$i18n.t('productslist_restore_fail_msg_title'),
                        this.$i18n.t('productslist_restore_fail_msg_content'),
                        false
                    );
                }
            } catch (error) {
                console.log(error);
                await oneBtnDialog(this.$i18n.t('productslist_restore_err_msg_title'), this.$i18n.t('productslist_restore_err_msg_content'), false);
            }
        },
        async enter() {
            if (this.searchFilter === '') {
                await oneBtnDialog(this.$i18n.t('productslist_search_empty_filter_err_title'), this.$i18n.t('productslist_search_empty_filter_err_content'), false);
            } else {
                this.paginationData.currentPage = 1;
                this.getProductsList();
            }
        },
        async handleRowsPerPage() {
            this.paginationData.currentPage = 1;
            await this.getProductsList();
        },
        // 인증서 상태 코드 텍스트로 변환
        convertCodeToText(code) {
            const i18n = this.$i18n;
            switch (code) {
                case 'original-unissued':
                    return i18n.t('productslist_original_unissued');
                case 'original-issued':
                    return i18n.t('productslist_original_issued');
                case 'customer-issued':
                    return i18n.t('productslist_customer_issued');
                case 'unlimited-issued':
                    return i18n.t('productslist_unlimited_issued');
                case 'hospital-issued':
                    return i18n.t('productslist_hospital_issued');
                case 'dispose':
                    return i18n.t('productslist_disposed');
                default:
                    return '-';
            }
        },
        async uploadBulkFile() {
            try {
                this.clickFileInput();

                const file = await new Promise(resolve => {
                    this.$refs.bulkFileInput.onchange = (event) => {
                    resolve(event.target.files[0]);
                    };
                });
                
                const isValid = this.validateFile(file);
                if (!isValid) return;

                const formData = new FormData();
                formData.append('file', file);
                
                const objectStorageUrl = await this.uploadExcelOnObjectStorage(formData);
                
                if(objectStorageUrl) {
                    const obj = {};
                    obj.url = objectStorageUrl;
                    const response = await this.$apiInstance.post(`/products/import/excel/datas`, obj);
                    if(response.status === 200 || response.status === 201) {
                        await oneBtnDialog(this.$i18n.t('productslist_upload_succeess_title'), this.$i18n.t('productslist_upload_succeess_content'), true);
                    }
                }

            } catch (error) {
                console.error("Error uploading the file:", error);
                if(error.response && error.response.status === 400) {
                    await oneBtnDialog(this.$i18n.t('productslist_upload_no_item_title'), this.$i18n.t('productslist_upload_no_item_content'), false);
                } else {
                    await oneBtnDialog(this.$i18n.t('productslist_upload_fail_title'), this.$i18n.t('productslist_upload_fail_content'), false);
                }
            }
        },
        clickFileInput() {
            if(this.$refs.bulkFileInput) this.$refs.bulkFileInput.click();
        },
        async uploadExcelOnObjectStorage(fileData) {
            try {
                const response = await this.$apiInstance.post(`/object-storages/excel`, fileData);
                if (response.status === 200 || response.status === 201) {
                    return response.data.url;
                } else {
                    return '';
                }
            } catch(error) {
                console.log(error);
                await oneBtnDialog(this.$i18n.t('productslist_upload_err_msg_title'), this.$i18n.t('productslist_upload_err_msg_content'), false);
                return '';
            }
        },
        validateFile(file) {
            let result = true;
            if(file) {
                if(!file.name.endsWith('.xlsx')) {
                    alert(this.$i18n.t('productslist_message_filetype'));
                    result = false;
                } else if(changeBytesToMegabytes(file.size) > 100) {
                    alert(this.$i18n.t('hospitalw_message_file_size'));
                    result = false;
                }
            } 
            return result;
        },
        async downloadBulkExample() {
            const formattedDate = dayjs().format("YYYYMMDD");
            try {
                const response = await this.$apiInstance.get(`/products/export/excel/form`, { responseType: 'blob'});

                if (response.status === 200 || response.status === 201) {
                    const blob = new Blob([response.data], {
                        type: 'application/octet-stream',
                    });

                    const url = URL.createObjectURL(blob);

                    const downloadLink = document.createElement('a');
                    downloadLink.href = url;
                    downloadLink.download = `${this.$i18n.t('productslist_filename')}_${formattedDate}.xlsx`;
                    downloadLink.click();

                    URL.revokeObjectURL(url);
                } else {
                    // Handle the error case
                }
            } catch (error) {
                console.error(error);
                await oneBtnDialog(this.$i18n.t('productslist_download_err_title'), this.$i18n.t('productslist_download_err_content'), false);
            }
        },
    },
};
</script>
<style lang="scss">

@media screen and (max-width:767px) {
  //개별 등록
  #productDetailWriteModal{
    padding: 20px;
    .modal-div-wrap .modal-input-div{
      flex-direction: column;
      input,
      select,
      textarea{
        width: 100% !important;
      }
    }
    .modal-div-wrap .modal-input-div .label-wrap{
      width: 100%;
    }
  }
}
</style>
<style lang="scss" scoped>

@media screen and (max-width:767px) {
  
  .search-container {
    gap: 8px !important;
    .search-div {
        flex-direction: row;
        gap: 0px;
        background-color: initial !important;
        select{
            width: 150px !important;
        }
        .typing-area{
            width: 100%;
            gap: 0;
        }
    }
  }

  // 제품관리 목록화면
  .container-fluid .row.justify-content-center{
    padding: 14px 14px 36px 14px !important;
  }
  .mainDiv{
    width: 100% !important;
  }
  .header-btn{
    margin-left: auto;
  }
  .CertListTitle {
      width: 100%;
    .d-flex.gap-2{
      width: 100%;
      flex-direction: column;
      button{
        width: 100%;
        word-break: keep-all;
        text-align: left;
      }
    }
  }
  .table-with-search .table-info-filter{
    flex-direction: column;
    align-items: flex-start;
    flex: none;
    justify-content: flex-start;
    height: 210px;
  }
  .table-with-search .search-container .search-div input,
  .table-with-search .search-container .search-div button{
    width: 60px !important;
    min-width: auto;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
  .table-with-search .search-container .search-div input{
    width: calc(100% - 60px)!important;
  }
  #searchFilter{
    display: flex;
    flex-wrap: row;
  }
   .table-with-search .search-container,
   .table-with-search .search-container .search-div,
   .table-with-search .search-container select{
    width: 100%;
    flex: none;
   }
}

@media screen and (min-width:768px) and (max-width:1023px){
  .header-btn{
    padding: 12px;
  }
  .table-with-search .table-info-filter{
    flex-direction: column;
    width: 100%;
    .total-div{
      margin-right: auto;
    }
    .search-container{
      width: 100%;
      flex-direction: row;
      .search-div{
        flex-direction: row;
        width: 100%;
        input{
          width: calc(100% - 80px) !important;
        }
        .search-btn{
          min-width: 80px;
        }
      }
    }
  }

}
</style>